// extracted by mini-css-extract-plugin
export default {"container":"af0q2d"};